'use strict';

var $ = require('jquery'),
    carousel = require('../components/carousel');

exports.init = function () {
    $('#notempty');
    carousel.init();
};
